<template>
  <adminTable :tableLoading="tableLoading" :totalList="totalList" v-model:page="page" v-model:limit="limit"
    v-model:searchForm="searchForm" :tableData="tableData" @search="getList">
    <template v-slot:form-inline-items>
      <el-form-item>
        <el-input v-model="searchForm.ip" placeholder="搜索IP" clearable />
      </el-form-item>
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="uid" label="用户ID" width="130" />
      <el-table-column prop="username" label="用户名" width="160" />
      <el-table-column prop="login_ip" label="ip" width="130" />
      <el-table-column prop="ip_address" label="ip地址" width="130" />
      <el-table-column prop="login_agent" label="浏览器信息" width="400" />
      <el-table-column prop="create_time" label="登录时间" width="200">
      </el-table-column>
    </template>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";

const searchForm = ref({
  ip: "",
});

onMounted(() => {
  getList();
});

const { proxy } = getCurrentInstance();

const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);
const tableData = ref([]);

const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    type: "get",
    url: "/Systemuserlog/getSystemUserLogLists",
    params: {
      page: page.value,
      limit: limit.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};


</script>

<style lang="less" scoped></style>
